<template>
  <ClientOnly v-if="section.size.value === 'none'">
    <ContentCustomHtml
      :css="section.css"
      :html="section.html"
      :js="section.js"
    />
  </ClientOnly>
  <SectionContainer
    v-else
    :bg-color="
      section.bgColor.value === 'none' ? undefined : section.bgColor.value
    "
    :size="sectionSize"
  >
    <ClientOnly>
      <ContentCustomHtml
        :css="section.css"
        :html="section.html"
        :js="section.js"
      />
    </ClientOnly>
  </SectionContainer>
</template>

<script setup lang="ts">
import { ClientOnly } from "#components";
import { computed } from "vue";

import type { Section } from "~/features/product/api/cms.api.ts";

import ContentCustomHtml from "~/shared/components/content-blocks/ContentCustomHtml.vue";
import SectionContainer from "~/shared/components/SectionContainer.vue";

type CustomHtmlSection = Extract<Section, { type: "customHtmlSection" }>;

const props = defineProps<{
  section: CustomHtmlSection;
}>();

const sectionSize = computed<"lg" | "md" | "sm" | undefined>(() => {
  const { value } = props.section.size;
  return value === "default" || value === "none" ? undefined : value;
});
</script>
